// extracted by mini-css-extract-plugin
module.exports = {"box":"Package_box__2QqZa","title":"Package_title__3krJB","wrapper":"Package_wrapper__20ccQ"};